import "./_photos.scss";

import {useEffect, useState} from "react";

import noPicture from "@/assets/massification/iconNoPicture.png";
import {Modale} from "@/components/Modale/Modale";

function Photos({photos}: {photos?: string[]}): JSX.Element | null {
  // contient la photo à afficher ainsi que l'index à la quelle elle se trouve dans toutes les photos
  const [photoUse, setPhotoUse] = useState<{photo: string; index: number}>(
    photos?.[0] ? {photo: photos[0], index: 0} : {photo: noPicture, index: 0},
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);
  useEffect(() => {
    setPhotoUse(
      photos?.[0] ? {photo: photos[0], index: 0} : {photo: noPicture, index: 0},
    );
  }, [photos]);
  const photosMin: (JSX.Element | null)[] | undefined = photos?.map(
    (photo, index) => {
      return index != photoUse.index ? (
        <img
          key={index}
          src={photo}
          alt={"Photo de présentation du produit"}
          onClick={() => {
            setPhotoUse({photo: photo, index: index});
          }}
        />
      ) : null;
    },
  );
  return (
    <div className="photos">
      <Modale
        isOpen={isOpen}
        close={() => {
          setIsOpen(false);
        }}
        title={""}>
        <img
          className="photos-modale"
          src={photoUse.photo}
          alt={"Photo de présentation du produit"}
        />
      </Modale>
      <img
        className="photos-principal"
        src={photoUse.photo}
        alt={"Photo de présentation du produit"}
        onClick={() => {
          setIsOpen(true);
        }}
      />
      <div className="photos-miniature">{photosMin}</div>
    </div>
  );
}

export default Photos;
